import { render, staticRenderFns } from "./bloodPressure.vue?vue&type=template&id=3c3e004f&scoped=true"
import script from "./bloodPressure.vue?vue&type=script&lang=js"
export * from "./bloodPressure.vue?vue&type=script&lang=js"
import style0 from "./bloodPressure.vue?vue&type=style&index=0&id=3c3e004f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e004f",
  null
  
)

export default component.exports